import { UntypedFormControl } from "@angular/forms";
import { isValidNumber } from "libphonenumber-js";
import moment from "moment";

export const validatePhoneNumber = (formControl: UntypedFormControl) => {
  const value = formControl.value as string;
  return isValidNumber(value?.replace(/\s/g, "") || "")
    ? null
    : { phoneNumberInvalid: true };
};

export const validateNonRequiredPhoneNumber = (
  formControl: UntypedFormControl,
) => (!formControl.value ? null : validatePhoneNumber(formControl));

export const validateFutureDate = (formControl: UntypedFormControl) => {
  const value = formControl.value as string | number | Date | null | undefined;
  if (value == null || value === "") {
    return null;
  }
  return new Date(value) > new Date() ? null : { dateInvalid: true };
};

export const validateNotPastDate = (formControl: UntypedFormControl) => {
  const value = formControl.value as moment.MomentInput;
  return moment().subtract(1, "days").endOf("day").isBefore(moment(value))
    ? null
    : { dateInvalid: true };
};

export const greaterThan = (toCompareControlName: string) => {
  return (control: UntypedFormControl): { [key: string]: boolean } | null => {
    if (!control.parent) {
      return null;
    }

    const toCompareControl = control.parent.get(toCompareControlName);
    if (!toCompareControl) {
      return null;
    }
    const toCompareValue = toCompareControl.value as number;
    const controlValue = control.value as number;
    if (controlValue > toCompareValue) {
      return null;
    }

    return { greaterThanInvalid: true };
  };
};

export const lowerThan = (toCompareControlName: string) => {
  return (control: UntypedFormControl): { [key: string]: boolean } | null => {
    if (!control.parent) {
      return null;
    }

    const toCompareControl = control.parent.get(toCompareControlName);
    if (!toCompareControl) {
      return null;
    }
    const toCompareValue = toCompareControl.value as number;
    const controlValue = control.value as number;
    if (!toCompareValue || controlValue < toCompareValue) {
      return null;
    }

    return { lowerThanInvalid: true };
  };
};
